import { useState } from "react";
import { useService } from "@infrastructure/api/hooks/use-service";
import { Requests } from "@infrastructure/api/requests";
import { FullPageLoader } from "@presentation/shared/components/loader/FullPageLoader";
import * as React from "react";
import { PageLayout } from "@presentation/shared/layout/PageLayout";
import { Program } from "@presentation/pages/programs/Program";
import { priceEuro } from "@presentation/shared/utils/price-format";
import { ProgramType } from "@presentation/pages/programs/types";

export function Programs() {
  const { loading, data } = useService(Requests.programs, true);

  const [selected, setSelected] = useState<ProgramType>(null);

  if (selected) {
    return <Program program={selected} onBack={() => setSelected(null)} />;
  }

  return (
    <PageLayout>
      {loading && <FullPageLoader />}
      <div className="container mx-auto prose-lg py-4 mt-8">
        <div className="grid gap-8 items-center grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {data?.map((program) => {
            const { adl_bruto_price, image, name } = program;
            return (
              <div
                className="flex flex-col rounded-md border border-primary-50 hover:shadow-xl cursor-pointer mb-10 sm:mb-0"
                onClick={() => setSelected(program)}
              >
                <div
                  className="bg-cover bg-center min-h-[200px]"
                  style={{ backgroundImage: `url(${image?.thumb})` }}
                />
                <div className="flex flex-col flex-grow px-4 py-2">
                  <div className="font-bold text-lg">{name}</div>
                  <div className="text-right font-bold">
                    {priceEuro(adl_bruto_price)} / p
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </PageLayout>
  );
}
